import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/reusables/topic-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/build/src/components/ui/aspect-ratio.tsx");
